import { SET_FINAL_FORM } from './constants';

export function setFinalForm(
    namespace: string,
    finalForm: Record<string, any>
) {
    return {
        type: SET_FINAL_FORM,
        payload: {
            namespace,
            finalForm
        }
    };
}
